export const MAX_CARD_COUNT_TO_SHOW_MOBILE = 4;
